var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrectmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#686369"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1173 5.57251C13.1734 5.6206 13.2195 5.67929 13.2529 5.7452C13.2863 5.81112 13.3064 5.88298 13.3121 5.95667C13.3177 6.03036 13.3088 6.10444 13.2858 6.17468C13.2628 6.24492 13.2262 6.30993 13.178 6.36601L8.67803 11.616C8.62758 11.6749 8.5655 11.7227 8.4957 11.7564C8.4259 11.7901 8.34988 11.8091 8.27241 11.812C8.19495 11.815 8.1177 11.8019 8.04553 11.7736C7.97336 11.7453 7.90782 11.7024 7.85303 11.6475L5.22803 9.02251C5.12562 8.91637 5.06899 8.77426 5.07034 8.62677C5.07169 8.47929 5.13091 8.33823 5.23525 8.23399C5.33959 8.12974 5.4807 8.07065 5.62819 8.06944C5.77568 8.06823 5.91774 8.12499 6.02378 8.22751L8.21978 10.4228L12.3245 5.63401C12.4216 5.5209 12.5597 5.45096 12.7083 5.43957C12.857 5.42818 13.0041 5.47552 13.1173 5.57251Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectmark);
export default __webpack_public_path__ + "static/media/correctmark.af0df664e0337b68acd89f6326c49610.svg";
export { ForwardRef as ReactComponent };